export enum ProjectType {
    Approved = 1,
    Rejected = 2,
    Pending = 3,
    ApprovedDescription = "Approved",

    RejectedDescription = "Rejected",
    PendingDescription = "Pending",


}
